import styled from 'styled-components';

import { PStyled } from 'approot/shared/styles/typography.style';

export const SettingsSentenceWrapper = styled.div`
  max-width: 100%;
  overflow: hidden;
`;

export const SettingsSentence = styled(PStyled).attrs({
  marginBottom: 0,
})`
  white-space: normal;
`;

export const SettingsSentenceIcon = styled.div`
  flex-shrink: 0;
`;
